import * as React from 'react';
import { Label, UIText2, UIHeading4 } from '@cian/ui-kit';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FlatCard = function FlatCard(_ref) {
  var flat = _ref.flat,
    onClick = _ref.onClick,
    FavoriteButton = _ref.favoriteButton;
  var price = flat.price,
    hasDecoration = flat.hasDecoration,
    description = flat.description,
    url = flat.url,
    dueDate = flat.dueDate;
  return /*#__PURE__*/_jsxs("a", {
    target: "_blank",
    rel: "noreferrer",
    href: url,
    className: style['card'],
    id: "flatcardid-".concat(flat.offerId),
    onClick: onClick,
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['description'],
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: style['date'],
          children: /*#__PURE__*/_jsx(UIText2, {
            color: "current_color",
            whiteSpace: "nowrap",
            children: dueDate
          })
        }), /*#__PURE__*/_jsx(UIHeading4, {
          color: "current_color",
          children: price
        }), /*#__PURE__*/_jsx(UIText2, {
          color: "current_color",
          whiteSpace: "nowrap",
          children: description
        })]
      }), hasDecoration && /*#__PURE__*/_jsx("div", {
        className: style['description-labels'],
        children: /*#__PURE__*/_jsx(Label, {
          color: "dark_100",
          background: "gray6_100",
          children: "\u0421 \u043E\u0442\u0434\u0435\u043B\u043A\u043E\u0439"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style['actions'],
      children: /*#__PURE__*/_jsx(FavoriteButton, {
        initialFavoriteState: flat.isFavorite,
        offerId: flat.offerId
      })
    })]
  });
};